import { Plus } from "lucide-react";
import { useGetList, type Identifier } from "ra-core";
import { useState } from "react";

import { Button } from "@/components/ui/button";

import type { GulaTask } from "./gulaTasks";
import { NewTaskDialog } from "./NewTaskDialog";
import { TaskRow } from "./TaskRow";
import { useAgents } from "./useAgents";

/** Open tasks about one client, with a shortcut to add another. */
export const ClientTasks = ({
  contactId,
  name,
}: {
  contactId: Identifier;
  name: string;
}) => {
  const { agents } = useAgents();
  const [isNewOpen, setNewOpen] = useState(false);
  const { data: tasks = [], refetch } = useGetList<GulaTask>("tasks", {
    filter: { contact_id: contactId, "done_date@is": null },
    pagination: { page: 1, perPage: 50 },
    sort: { field: "due_date", order: "ASC" },
  });

  return (
    <section className="flex flex-col gap-1">
      <div className="flex items-center justify-between">
        <h4 className="text-sm font-semibold">Tareas</h4>
        <Button variant="ghost" size="sm" onClick={() => setNewOpen(true)}>
          <Plus className="h-4 w-4" />
          Nueva tarea
        </Button>
      </div>
      {tasks.length ? (
        <div className="divide-y rounded-md border px-3">
          {tasks.map((task) => (
            <TaskRow
              key={task.id}
              task={task}
              agents={agents}
              onChanged={() => refetch()}
            />
          ))}
        </div>
      ) : (
        <p className="text-sm text-muted-foreground">Sin tareas pendientes.</p>
      )}
      <NewTaskDialog
        open={isNewOpen}
        onClose={() => setNewOpen(false)}
        onCreated={() => {
          setNewOpen(false);
          refetch();
        }}
        preset={{ contactId, name }}
      />
    </section>
  );
};
